import React from 'react';
import styles from './TableOfContents.module.scss';

const TableOfContents = ({ items }) => {
  return (
    <aside className={styles.toc}>
      <div className={styles.actionsContainer}>
        <div className={styles.suggestEdits}>
          {/* <a href="#suggest-edits">
            <span className="material-icons">drive_file_rename_outline</span>
            Suggest Edits
          </a> */}
        </div>
        {/* <div className={styles.askAi}>
          <button>
            <span className="material-icons">psychology_alt</span>
            Ask AI
          </button>
        </div> */}
      </div>
      <h5 className={styles.tocTitle}>Table of Contents</h5>
      <nav>
        <ul>
          {items.map((item, index) => (
            <li key={index} className={styles[`level${item.level}`]}>
              <a href={item.href}>{item.title}</a>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default TableOfContents;